import { AppBar, IconButton, ListItemButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './MenuBar.scss';
import {
    Switch,
    Route,
    Link,
} from "react-router-dom";
import RightMenu from '../RightMenu/RightMenu';
import { useSelector } from 'react-redux';
import { userProfileSelector } from '../Login/reducers/UserProfileReducer';
import { UserGroupEnum } from '../UserManagement/UserGroupEnum';
import _ from 'lodash';

export const isInRole = (userGroup: string, roles: UserGroupEnum[]) => {
    var indexOfKey = Object.keys(UserGroupEnum).indexOf(userGroup as unknown as UserGroupEnum);

    return _.findIndex(roles, (role) => {
        return role === Object.values(UserGroupEnum)[indexOfKey];
    }) > -1;
}

const MenuBar: React.FunctionComponent = () => {
    let [selectedMenu, setSelectedMenu] = useState<string>();
    const userProfile = useSelector(userProfileSelector);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        setSelectedMenu(window.location.pathname);
    }, [])

    let getClass = (menuName: string) => {
        if (menuName === "/tonnage" && selectedMenu === "/") {
            return "active menu-item";
        }

        return selectedMenu === menuName ? "active menu-item" : "menu-item";
    }



    return (
        <>
            <AppBar position="static">
                <Toolbar className="header">
                    <div className="logo">
                        <img src="/img/card-minh-ascentbulk-in.png" />
                    </div>
                    {
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator, UserGroupEnum.Broker, UserGroupEnum.TraineeBroker])) &&
                        <>
                            <Link to="/tonnage"
                                onClick={() => {
                                    setSelectedMenu("/tonnage");
                                }}>
                                <ListItemButton className={getClass("/tonnage")}>Tonnage</ListItemButton>
                            </Link>
                            <Link to="/cargo"
                                onClick={() => {
                                    setSelectedMenu("/cargo");
                                }}>
                                <ListItemButton className={getClass("/cargo")}>Cargo</ListItemButton>
                            </Link>
                            <Link to="/contact"
                                onClick={() => {
                                    setSelectedMenu("/contact");
                                }}>
                                <ListItemButton className={getClass("/contact")}>Contact</ListItemButton>
                            </Link>
                            <Link to="/brokeraccount"
                                onClick={() => {
                                    setSelectedMenu("/brokeraccount");
                                }}>
                                <ListItemButton className={getClass("/brokeraccount")}>Broker Account</ListItemButton>

                            </Link>
                            <Link to="/marketinfo"
                                onClick={() => {
                                    setSelectedMenu("/marketinfo");
                                }}>
                                <ListItemButton className={getClass("/marketinfo")}>Market Info</ListItemButton>
                            </Link>
                            <Link to="/stats"
                                onClick={() => {
                                    setSelectedMenu("/stats");
                                }}>
                                <ListItemButton className={getClass("/stats")}>Stats</ListItemButton>
                            </Link>
                            <Link to="/marketingemail"
                                onClick={() => {
                                    setSelectedMenu("/marketingemail");
                                }}>
                                <ListItemButton className={getClass("/marketingemail")}>Marketing Email</ListItemButton>
                            </Link>
                        </>
                    }
                    {
                        //guest
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Guest])) &&
                        <>
                            <Link to="/tonnage"
                                onClick={() => {
                                    setSelectedMenu("/tonnage");
                                }}>
                                <ListItemButton className={getClass("/tonnage")}>Tonnage</ListItemButton>
                            </Link>
                            <Link to="/cargo"
                                onClick={() => {
                                    setSelectedMenu("/cargo");
                                }}>
                                <ListItemButton className={getClass("/cargo")}>Cargo</ListItemButton>
                            </Link>
                            <Link to="/marketinfo"
                                onClick={() => {
                                    setSelectedMenu("/marketinfo");
                                }}>
                                <ListItemButton className={getClass("/marketinfo")}>Market Info</ListItemButton>
                            </Link>
                        </>
                    }
                    {
                        //support
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator])) &&
                        <>
                            <Link to="/evbemail"
                                onClick={() => {
                                    setSelectedMenu("/evbemail");
                                }}>
                                <ListItemButton className={getClass("/evbemail")}>EVB Email</ListItemButton>
                            </Link>
                        </>
                    }
                    {
                        //support
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator, UserGroupEnum.Support, UserGroupEnum.SupportManager, UserGroupEnum.Broker, UserGroupEnum.TraineeBroker, UserGroupEnum.Finance, UserGroupEnum.Care])) &&
                        <>
                            <Link to="/summary"
                                onClick={() => {
                                    setSelectedMenu("/summary");
                                }}>
                                <ListItemButton className={getClass("/summary")}>Summary</ListItemButton>
                            </Link>
                        </>
                    }
                    {
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator, UserGroupEnum.Support, UserGroupEnum.SupportManager])) &&
                        <Link to="/support"
                            onClick={() => {
                                setSelectedMenu("/support");
                            }}>
                            <ListItemButton className={getClass("/support")}>Support</ListItemButton>
                        </Link>
                    }
                    {
                        //support
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator, UserGroupEnum.Support, UserGroupEnum.SupportManager, UserGroupEnum.TraineeBroker, UserGroupEnum.Broker])) &&
                        <>

                            <Link to="#" onClick={handleClick}>
                                <ListItemButton className={getClass("/support-data")}>Support Data</ListItemButton>
                            </Link>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <Link to="/agent"
                                    onClick={() => {
                                        setSelectedMenu("/agent");
                                    }}>
                                    <MenuItem onClick={handleClose}>
                                        Agent
                                    </MenuItem>
                                </Link>
                                <Link to="/companynamepic"
                                    onClick={() => {
                                        setSelectedMenu("/companynamepic");
                                    }}>
                                    <MenuItem onClick={handleClose}>
                                        Company Name - PIC
                                    </MenuItem>
                                </Link>
                                <Link to="/surveyor"
                                    onClick={() => {
                                        setSelectedMenu("/surveyor");
                                    }}>
                                    <MenuItem onClick={handleClose}>
                                        Surveyor
                                    </MenuItem>
                                </Link>
                            </Menu>
                        </>
                    }
                    {
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator, UserGroupEnum.Finance])) &&
                        <>
                            <>
                                {/* <Link to="/cash"
                                    onClick={() => {
                                        setSelectedMenu("/cash");
                                    }}>
                                    <ListItemButton className={getClass("/cash")}>Cash</ListItemButton>
                                </Link>
                                <Link to="/investment"
                                    onClick={() => {
                                        setSelectedMenu("/investment");
                                    }}>
                                    <ListItemButton className={getClass("/investment")}>Investment</ListItemButton>
                                </Link> */}
                                <Link to="/expense"
                                    onClick={() => {
                                        setSelectedMenu("/expense");
                                    }}>
                                    <ListItemButton className={getClass("/expense")}>Expense</ListItemButton>
                                </Link>
                                {/* <Link to="/stock"
                                    onClick={() => {
                                        setSelectedMenu("/stock");
                                    }}>
                                    <ListItemButton className={getClass("/stock")}>Stock</ListItemButton>
                                </Link> */}
                                <Link to="/totalsummary"
                                    onClick={() => {
                                        setSelectedMenu("/totalsummary");
                                    }}>
                                    <ListItemButton className={getClass("/totalsummary")}>Total Summary</ListItemButton>
                                </Link>
                            </>
                        </>
                    }
                    {
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator, UserGroupEnum.Care, UserGroupEnum.Broker, UserGroupEnum.TraineeBroker, UserGroupEnum.Finance])) &&
                        <>
                            <Link to="/classification"
                                onClick={() => {
                                    setSelectedMenu("/classification");
                                }}>
                                <ListItemButton className={getClass("/classification")}>Classification</ListItemButton>
                            </Link>
                            <Link to="/care"
                                onClick={() => {
                                    setSelectedMenu("/care");
                                }}>
                                <ListItemButton className={getClass("/care")}>Care</ListItemButton>
                            </Link>
                        </>
                    }
                    {
                        (isInRole(userProfile.userGroup, [UserGroupEnum.Administrator])) &&
                        <>
                            <Link to="/admintools"
                                onClick={() => {
                                    setSelectedMenu("/admintools");
                                }}>
                                <ListItemButton className={getClass("/admintools")}>Admin Tools</ListItemButton>
                            </Link>
                        </>
                    }
                    <RightMenu>
                    </RightMenu>
                </Toolbar>
            </AppBar >
        </>
    )
};

export default MenuBar;